export const ASSESSMENTS_SET = 'ASSESSMENTS_SET';
export const ASSESSMENTS_UPDATE = 'ASSESSMENTS_UPDATE';
export const ASSESSMENT_SET = 'ASSESSMENT_SET';
export const ASSESSMENT_STEP_SET = 'ASSESSMENT_STEP_SET';
export const ASSESSMENT_REMOVE = 'ASSESSMENT_REMOVE';
export const ASSESSMENT_UPDATE = 'ASSESSMENT_UPDATE';
export const ASSESSMENTS_RESET = 'ASSESSMENTS_RESET';
export const ASSESSMENTS_ERROR = 'ASSESSMENTS_ERROR';
